module.exports = __webpack_public_path__ + "static/media/us.dfe23289.svg";